import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsGroupByTable extends Layout {
    buttonClearSelections: Button;
    labelTitle: Label;
    sourceCommissionsProcessing: DataSource;
    tableGroupBy: Table;
}
